import { createSlice } from '@reduxjs/toolkit';
import { fetchTemplates, fetchTemplateById, fetchVariables } from './actions';

const initialState = {
  data: {},
  isLoading: true,
  template: {},
  error: null,

  isVariablesLoading: true,
  variables: [],
  variablesError: null,
};

const { reducer } = createSlice({
  name: 'templates',
  initialState,

  extraReducers: {
    [fetchTemplates.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    [fetchTemplates.fulfilled]: (state, { payload }) => {
      state.data = payload?.data || {};
      state.isLoading = false;
      state.error = null;
    },
    [fetchTemplates.rejected]: (state, { error }) => {
      state.isLoading = false;
      state.error = error.message || 'Failed to fetch templates';
    },

    [fetchTemplateById.pending]: (state, { meta }) => {
      const { templateId } = meta?.arg;
      state.template[templateId] = { isLoading: true, error: null };
    },
    [fetchTemplateById.fulfilled]: (state, { meta, payload }) => {
      const { templateId } = meta?.arg;
      state.template[templateId] = {
        ...(payload?.data || {}),
        isLoading: false,
        error: null,
      };
    },
    [fetchTemplateById.rejected]: (state, { meta, error }) => {
      const { templateId } = meta?.arg;
      state.template[templateId] = {
        isLoading: false,
        error: error.message || 'Failed to fetch template',
      };
    },

    [fetchVariables.pending]: (state) => {
      state.isVariablesLoading = true;
      state.variablesError = null;
    },
    [fetchVariables.fulfilled]: (state, { payload }) => {
      state.variables = payload?.data?.variables || {};
      state.isVariablesLoading = false;
      state.variablesError = null;
    },
    [fetchVariables.rejected]: (state, { error }) => {
      state.isVariablesLoading = false;
      state.variablesError = error.message || 'Failed to fetch variables';
    },
  },
});

export default reducer;
